////////////////////////////////////////////////Modal
if (!customElements.get("dl-js-modal")) {
  // モーダルの生成
  var ModalHtml = `
  <div class='dl-common__parts'>
    <div class='dl-js-modal'>
      <div class='dl-js-modal__wrap'>
        <div class='dl-js-modal__loading'><span></span></div>
        <dl-js-modal__close class='dl-js-modal__close__base'></dl-js-modal__close>
        <div class='dl-js-modal__content'>
          <dl-js-modal__close class='dl-js-modal__close__head'><span></span></dl-js-modal__close>
          <div class='dl-js-modal__content__wrap'>
          </div>
          <dl-js-modal__close class='dl-js-modal__close__foot'><span><span></span>CLOSE</span></dl-js-modal__close>
        </div>
      </div>
    </div>
  </div>
  `;

  document.querySelector("main").insertAdjacentHTML("afterend", ModalHtml);
  class DL_ModalClose extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "click",
        function () {
          document.body.style.overflow = "inherit";
          DL_fadeOut(document.querySelector(".dl-js-modal"), 300, function () {
            for (
              var i = 0;
              i < document.querySelectorAll("dl-js-modal").length;
              i++
            ) {
              document.querySelectorAll("dl-js-modal")[i].style.display =
                "none";
            }

            for (
              var i = 0;
              i <
              document.querySelectorAll("dl-js-modal-store-switcher").length;
              i++
            ) {
              document.querySelectorAll("dl-js-modal-store-switcher")[
                i
              ].style.display = "none";
            }

            document.querySelector(".dl-js-modal__content").style.display =
              "none";
          });
        },
        false
      );
    }
  }

  customElements.define("dl-js-modal__close", DL_ModalClose);

  class DL_Modal extends HTMLElement {
    constructor() {
      super();
      const modal = this;
      document.querySelector(".dl-js-modal__content__wrap").appendChild(this);
      modal.name = modal.getAttribute("data-modal");
      modal.botton = document.querySelectorAll(
        '.dl-js-modal__open[data-modal="' + modal.name + '"]'
      );
      for (var i = 0; i < modal.botton.length; i++) {
        modal.botton[i].addEventListener(
          "click",
          function () {
            modal.open();
          },
          false
        );
      }
    }
    open() {
      const modal = this;
      if (document.querySelector(".dl-js-modal").style.display != "block") {
        DL_fadeIn(document.querySelector(".dl-js-modal"), 300, function () {
          document.body.style.overflow = "hidden";
          modal.style.display = "block";
          DL_fadeIn(document.querySelector(".dl-js-modal__content"), 400);
        });
      } else {
        DL_fadeOut(
          document.querySelector(".dl-js-modal__content"),
          300,
          function () {
            for (
              var i = 0;
              i < document.querySelectorAll("dl-js-modal").length;
              i++
            ) {
              document.querySelectorAll("dl-js-modal")[i].style.display =
                "none";
            }

            for (
              var i = 0;
              i <
              document.querySelectorAll("dl-js-modal-store-switcher").length;
              i++
            ) {
              document.querySelectorAll("dl-js-modal-store-switcher")[
                i
              ].style.display = "none";
            }

            modal.style.display = "block";
            DL_fadeIn(document.querySelector(".dl-js-modal__content"), 300);
          }
        );
      }
    }
  }
  customElements.define("dl-js-modal", DL_Modal);

  class DL_Modal_Store_Switcher extends DL_Modal {
    constructor() {
      super();

      const modal = this;

      const lsPopupId = "storeSwitcherPopup";

      this.closest(".dl-js-modal")
        .querySelectorAll("dl-js-modal__close")
        .forEach((closeEl) => {
          closeEl.addEventListener("click", () => {
            localStorage.setItem(lsPopupId, "false");
          });
        });

      this.defaultCountry = this.dataset.defaultCountry;

      fetch("https://freeipapi.com/api/json")
        .then((res) => res.json())
        .then((res) => {
          const coveredCountries = ["eu", "gb", "jp", "us", "ca", "kr"];
          const continentCode = res.continentCode.toLowerCase();
          const countryCode = res.countryCode.toLowerCase();

          if (localStorage.getItem(lsPopupId) !== "false") {
            // // for testing
            // modal.open();

            if (continentCode === "eu") {
              if (
                (this.defaultCountry === "eu" && countryCode === "gb") ||
                (this.defaultCountry === "uk" && countryCode !== "gb")
              ) {
                modal.open();
              }
            } else {
              if (
                this.defaultCountry !== countryCode &&
                coveredCountries.includes(countryCode)
              ) {
                modal.open();
              }
            }
          }
        });

      this.shopNowButton = this.querySelector(".shop-now-button");

      if (this.shopNowButton) {
        this.shopNowButton.addEventListener("click", () => {
          localStorage.setItem(lsPopupId, "false");

          const country = this.querySelector(
            'dropdown-with-input[data-type="country"]'
          );
          const language = this.querySelector(
            'dropdown-with-input[data-type="language"]'
          );

          if (country.dataset.selectedOption === this.defaultCountry) {
            this.closest(".dl-js-modal")
              .querySelector(".dl-js-modal__close__head")
              .click();
          } else {
            if (country.dataset.selectedOption === "uk") {
              window.location.replace("https://kinto-europe.co.uk/");
            } else {
              window.location.replace("https://kinto-europe.com/");
            }
          }
        });
      }

      this.regionOptions = this.querySelectorAll(".modal-country-option");
      if (this.regionOptions) {
        this.regionOptions.forEach((option) => {
          option.addEventListener("click", (e) => {
            const url = e.target.dataset.url;
            const currentDomain = new URL(window.location.href).hostname;
            const currentPathname = window.location.pathname;
            const targetDomain = new URL(url).hostname;

            if (currentDomain !== targetDomain) {
              if (
                (currentDomain.includes("kinto-europe.co.uk") ||
                  currentDomain.includes("kinto-europe.com")) &&
                (targetDomain.includes("kinto-europe.co.uk") ||
                  targetDomain.includes("kinto-europe.com"))
              ) {
                const targetUrl = new URL(url).origin + currentPathname;
                console.log({ targetUrl });
                window.location.assign
                  ? window.location.assign(targetUrl)
                  : (window.location.href = targetUrl);
                return;
              }

              window.location.assign
                ? window.location.assign(url)
                : (window.location.href = url);
            } else {
              this.closest(".dl-js-modal")
                .querySelector(".dl-js-modal__close__head")
                .click();
            }
          });
        });
      }
    }
  }

  //     .forEach((option) => {
  //       console.log(option);
  //       option.addEventListener("click", (e) => {
  //         console.log(window.location.href);
  //         // const url = e.target.dataset.url;
  //         // if (url !== window.location.href) {
  //         //   window.location.replace
  //         //     ? window.location.replace(url)
  //         //     : (window.location.href
  //         //       = url);
  //         // } else {
  //         //   this.closest(".dl-js-modal")
  //         //     .querySelector(".dl-js-modal__close__head")
  //         //     .click();
  //         // }
  //       });
  //     });
  //   }
  // }
  customElements.define("dl-js-modal-store-switcher", DL_Modal_Store_Switcher);
}
